<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <!-- Reception -->
      <div
        class="col-xl-3 col-sm-6 mb-xl-0 mb-4"
        v-if="can('view-reception-from-visits-dashboard')"
      >
        <mini-statistics-card
          :issa_tally="true"
          :tally="apiData.reception"
          :title="' patients on queue'"
          value="Reception"
          @click="navigate_loc('/reception')"
          :percentage="{ value: '+505%', color: 'text-success' }"
          :icon="{ component: 'ni ni-badge', background: iconBackground }"
          direction-reverse
        />
      </div>

      <!-- Triage -->
      <div
        class="col-xl-3 col-sm-6 mb-xl-0 mb-4"
        v-if="
          can('view-triage-from-visits-dashboard') &&
          package_contains('general_clinic')
        "
      >
        <mini-statistics-card
          :issa_tally="true"
          :tally="apiData.triage"
          :title="' patients on queue'"
          value="Triage"
          @click="navigate_loc('/triage')"
          :percentage="{ value: '+3%', color: 'text-success' }"
          :icon="{ component: 'ni ni-world', background: iconBackground }"
          direction-reverse
        />
      </div>

      <!-- Consultation -->
      <div
        class="col-xl-3 col-sm-6 mb-xl-0 mb-4"
        v-if="
          can('view-consultation-from-visits-dashboard') &&
          package_contains('general_clinic')
        "
      >
        <mini-statistics-card
          :issa_tally="true"
          :tally="apiData.consultation"
          :title="' patients on queue'"
          value="Consultation"
          @click="navigate_loc('/consultation')"
          :percentage="{ value: '-2%', color: 'text-danger' }"
          :icon="{
            component: 'ni ni-paper-diploma',
            background: iconBackground,
          }"
          direction-reverse
        />
      </div>

      <!-- Laboratory -->
      <div
        class="col-xl-3 col-sm-6 mb-xl-0 mb-4"
        v-if="
          can('view-laboratory-from-visits-dashboard') &&
          package_contains('lab')
        "
      >
        <mini-statistics-card
          :issa_tally="true"
          :tally="apiData.lab"
          :title="' patients on queue'"
          value="Laboratory"
          @click="navigate_loc('/lab')"
          :percentage="{ value: '+5%', color: 'text-success' }"
          :icon="{ component: 'ni ni-atom', background: iconBackground }"
          direction-reverse
        />
      </div>

      <!-- Radiology -->
      <div
        class="col-xl-3 col-sm-6 mb-xl-0 mb-4"
        v-if="
          can('view-radiology-from-visits-dashboard') &&
          package_contains('radiology')
        "
      >
        <mini-statistics-card
          :issa_tally="true"
          :tally="apiData.radiology"
          :title="' patients on queue'"
          value="Radiology"
          @click="navigate_loc('/radiology')"
          :percentage="{ value: '+5%', color: 'text-success' }"
          :icon="{
            component: 'ni ni-camera-compact',
            background: iconBackground,
          }"
          direction-reverse
        />
      </div>

      <!-- Nursing Room -->
      <div
        class="col-xl-3 col-sm-6 mb-xl-0 mb-4"
        v-if="
          can('view-procedures-from-visits-dashboard') &&
          package_contains('procedures')
        "
      >
        <mini-statistics-card
          :issa_tally="true"
          :tally="apiData.nursing"
          :title="' patients on queue'"
          value="Procedures"
          @click="navigate_loc('/nursing_room')"
          :percentage="{ value: '+5%', color: 'text-success' }"
          :icon="{ component: 'ni ni-single-02', background: iconBackground }"
          direction-reverse
        />
      </div>

      <!-- Dialysis -->
      <!-- The component below is commented out in your original code, but I've added the permission for consistency. -->
      <div
        class="col-xl-3 col-sm-6 mb-xl-0 mb-4"
        v-if="
          can('view-dialysis-from-visits-dashboard') &&
          package_contains('dialysis')
        "
      >
        <mini-statistics-card
          :issa_tally="true"
          :tally="apiData.dialysis"
          :title="' patients on queue'"
          value="Dialysis"
          @click="navigate_loc('/dialysis_queue')"
          :percentage="{ value: '+5%', color: 'text-success' }"
          :icon="{ component: 'ni ni-support-16', background: iconBackground }"
          direction-reverse
        />
      </div>

      <div
        class="col-xl-3 col-sm-6 mb-xl-0 mb-4"
        v-if="
          can('view-dialysis-from-visits-dashboard') &&
          package_contains('dental')
        "
      >
        <mini-statistics-card
          :issa_tally="true"
          :tally="apiData.dialysis"
          :title="' patients on queue'"
          value="Dental Clinic"
          @click="navigate_loc('/dental_clinic/dental_queue')"
          :percentage="{ value: '+5%', color: 'text-success' }"
          :icon="{ component: 'fas fa-tooth', background: iconBackground }"
          direction-reverse
        />
      </div>

      <!-- Pharmacy -->
      <div
        class="col-xl-3 col-sm-6 mb-xl-0 mb-4"
        v-if="
          can('view-pharmacy-from-visits-dashboard') &&
          package_contains('pharmacy')
        "
      >
        <mini-statistics-card
          :issa_tally="true"
          :tally="apiData.pharmacy"
          :title="' patients on queue'"
          value="Pharmacy"
          @click="navigate_loc('/pharmacy')"
          :percentage="{ value: '+5%', color: 'text-success' }"
          :icon="{ component: 'ni ni-caps-small', background: iconBackground }"
          direction-reverse
        />
      </div>

      <!-- Cashier -->
      <div
        class="col-xl-3 col-sm-6 mb-xl-0 mb-4"
        v-if="can('view-cashier-from-visits-dashboard')"
      >
        <mini-statistics-card
          :issa_tally="true"
          :tally="apiData.cashier"
          :title="' patients on queue'"
          value="Cashier"
          @click="navigate_loc('/cashier')"
          :percentage="{ value: '+5%', color: 'text-success' }"
          :icon="{ component: 'ni ni-credit-card', background: iconBackground }"
          direction-reverse
        />
      </div>

      <!-- Receipts -->
      <div
        class="col-xl-3 col-sm-6 mb-xl-0 mb-4"
        v-if="can('view-receipts-from-visits-dashboard')"
      >
        <mini-statistics-card
          :issa_tally="true"
          :tally="apiData.receipts"
          :title="' generated'"
          value="Receipts"
          @click="navigate_loc('/receipts')"
          :percentage="{ value: '+5%', color: 'text-success' }"
          :icon="{
            component: 'ni ni-single-copy-04',
            background: iconBackground,
          }"
          direction-reverse
        />
      </div>

      <!-- Invoices -->
      <div
        class="col-xl-3 col-sm-6 mb-xl-0 mb-4"
        v-if="can('view-invoices-from-visits-dashboard')"
      >
        <mini-statistics-card
          title="- generated today"
          value="Invoices"
          @click="navigate_loc('/invoices')"
          :percentage="{ value: '+5%', color: 'text-success' }"
          :icon="{ component: 'ni ni-collection', background: iconBackground }"
          direction-reverse
        />
      </div>
      <!-- OTC PHARMACY -->
      <div
        class="col-xl-3 col-sm-6 mb-xl-0 mb-4"
        v-if="can('view-otc-pharmacy-from-visits-dashboard')"
      >
        <mini-statistics-card
          title="Old Visits"
          value="Past Visits"
          @click="navigate_loc('/visits/ended')"
          :percentage="{ value: '+5%', color: 'text-success' }"
          :icon="{ component: 'ni ni-box-2', background: iconBackground }"
          direction-reverse
        />
      </div>
    </div>
  </div>
</template>

<script>
import MiniStatisticsCard from "@/examples/Cards/MiniStatisticsCard.vue";
import { generalApiRequest } from "../../api/apiIndex";
import can from "../../permissions/permissions";
import package_contains from "../special_clinics/package_contains";

export default {
  name: "VisitsDashboard",
  components: {
    MiniStatisticsCard,
  },
  data() {
    return {
      iconBackground: "bg-gradient-primary",
      apiData: {},
    };
  },
  methods: {
    package_contains,
    navigate_loc(route) {
      console.log(route);

      window.location.href = route;
    },
    async callApi() {
      const url = "query_gp_departmental_queue_numbers"; //'getCompanyUsers?page=1';
      const body = {};
      const data = await generalApiRequest(url, "GET", body, 1);
      this.apiData = data;
      console.log(this.apiData.reception);
    },
    can, // <--- Added this to make the can() function available in the template
  },
  mounted() {
    this.callApi();
  },
};
</script>
